'use client'

import type { FC } from 'react'
import DaysAndTimesPicker from 'components/datetime/DaysAndTimesPicker'
import { Label } from 'ui/label'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

export const daysAndTimesFieldConfig = {
    getInitialValue: (field: TFormField) => ({
        days: (field.defaultValue as { days?: string[] })?.days || [],
        times: (field.defaultValue as { times?: Record<string, string[]> })?.times || {}
    }),
    validate: (field: TFormField, formState: Record<string, unknown>) => {
        if (!field.required) return
        const data = (formState[field.name] || {}) as { days?: string[] }
        const days = data?.days || []
        if (!days.length) return { [field.name]: 'At least one match day must be selected' }
        return
    }
} satisfies Partial<import('./types').FieldTypeConfig>

const DaysAndTimesField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    const data = (value || { days: [], times: {} }) as { days?: string[]; times?: Record<string, string[]> }

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <DaysAndTimesPicker
                options={field.options || []}
                placeholder={field.placeholder || 'Select days of the week'}
                value={data?.days || []}
                onChange={newValue => {
                    onChange(
                        field.name,
                        { days: newValue, times: data?.times || {} },
                        field
                    )
                }}
                allTimes={data?.times || {}}
                onTimesChange={newTimes => {
                    onChange(
                        field.name,
                        { days: data?.days ?? [], times: newTimes },
                        field
                    )
                }}
                onDaysAndTimesChange={fullValue => {
                    onChange(field.name, fullValue, field)
                }}
            />
        </FieldWrapper>
    )
}

export default DaysAndTimesField
